export default __webpack_public_path__ + "static/media/ColdEyes_tmb.c7202eb2.jpg";